import React from 'react';
import { CONTENTFUL_THEMES } from 'src/ui/Theme';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Theme } from '@mentimeter/ragnar-ui/themes';

export const TemplateSEOText = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Theme theme={CONTENTFUL_THEMES['plain']}>
    <Box width="100%" bg="bg" p={['space4', null, 'space8']}>
      {children}
    </Box>
  </Theme>
);
